import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { mapProps } from '../../../../../../../../../../../util/hocs';
import withModal from '../../../../../../../../../../../components/global/modal/withModal';
import EventCollage from './EventCollage';
import DismissButton from '../../../../../../../../../../../components/global/DismissButton';
import Angle from '../../../../../../../../../../../components/global/Angle';
import PurchasingOptionsPhotoPreview from '../../../PurchasingOptionsPhotoPreview';

export const EVENT_COLLAGES_MODAL = 'EVENT_COLLAGES_MODAL';

const propTypes = {
  className: PropTypes.string,
  eventCollages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      preview_image: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  ),
  photo: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const EventCollagesModalComponent = ({
  className,
  eventCollages,
  onClose,
  photo,
  ...props
}) => {
  const classes = classNames({
    [className]: !!className,
    'modal-contained-wrap': true,
  });

  return (
    <div className={classes}>
      <div className="purchasing-options-list-header modal-contained-header">
        <button className="btn-reset d-md-none" onClick={onClose}>
          <Angle direction="left" />
        </button>
        <span className="modal-contained-title">Select a collage</span>
        <DismissButton
          className="ml-auto d-none d-md-block"
          onClick={onClose}
        />
      </div>

      {photo && <PurchasingOptionsPhotoPreview photo={photo} />}

      <div className="modal-contained-content">
        <div className="purchasing-options-list-contents">
          {/* If a printProduct is directly passed do not pass the id */}
          {(eventCollages ?? []).map(eventCollage => (
            <EventCollage
              key={eventCollage.id}
              eventCollage={eventCollage}
              {...props}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

EventCollagesModalComponent.propTypes = propTypes;

const EventCollagesModal = withModal(
  mapProps(({ onClose, onRequestClose, actionProps = {}, ...props }) => ({
    onClose: onClose || onRequestClose,
    ...actionProps,
    ...props,
  }))(EventCollagesModalComponent),
  {
    name: EVENT_COLLAGES_MODAL,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
    className: 'event-collages-modal modal-contained',
  },
);

export default EventCollagesModal;
